export const setPerformanceConfig = axios => {
  // not applicable for web
};
